import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { EncryptionProviderService } from '@shared/services/encryption.service';
import { environment } from "../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private isLoaded = false;
  aboutUsData:any;
  constructor(
    private readonly http: HttpClient,
    private encryptionProviderService: EncryptionProviderService) { }
    loadGoogleMapsApi(): Promise<void> {
      if (this.isLoaded) {
        return Promise.resolve();
      }
  
      return new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          this.isLoaded = true;
          resolve();
        };
        script.onerror = (error) => reject(error);
        document.head.appendChild(script);
      });
    }
  public getData(endPoint: any): Observable<any> {
    return new Observable<void>((observer: any) => {
      this.http
        .get<any>(endPoint)
        .pipe(timeout(60000))
        .subscribe(
          (response) => {
            if (response['eData']) {
              response = JSON.parse(
                this.encryptionProviderService.decryptData(response['eData'])
              );
            }
            if (response.status === 0) {
              observer.next(response);
            } else {
              observer.error(response);
            }
          },
          (error) => {
            observer.error(error);
          },
          () => observer.complete()
        );
    });
  }

  public postData(endPoint: any, data: any): Observable<any> {
    return new Observable<void>((observer: any) => {
      if (environment.isEncryptionEnabled) {
        let dataTemp = !data ? {} : data;
        dataTemp.guid = this.generateGuid(endPoint);
        dataTemp.timeStamp = Date.now();
        data = {
          eData: this.encryptionProviderService.encryptData(
            JSON.stringify(dataTemp)
          ),
        };
      }
      this.http
        .post<any>(endPoint, data)
        .pipe(timeout(60000))
        .subscribe(
          (response) => {
            if (response['eData']) {
              response = JSON.parse(this.encryptionProviderService.decryptData(
                response['eData']
              ));
            }
            if (response.status === 0) {
              observer.next(response);
            } else {
              observer.error(response);
            }
          },
          (error) => {
            observer.error(error);
          },
          () => observer.complete()
        );
    });
  }

  generateGuid(url: string) {
    let result = '';
    const length = 32;
    const chars =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = length; i > 0; --i) {
      result += chars[Math.round(Math.random() * (chars.length - 1))];
    }

    this.encryptionProviderService.setGuid({
      key: url,
      value: result,
    });

    return result;
  }

  setAboutUsData(data){
  this.aboutUsData = data;
  }

  getAboutUsData(){
    return this.aboutUsData
  }

  filterAbtUsData(val){
    console.log(this.aboutUsData);
    if(this.aboutUsData){
      const data =  this.aboutUsData.data.sectionWiseData.find(ele=>{
        if(ele.subSectionName === val){
          return ele
        }
       })
       return data;
    }
    
    }

}
